// removed by extract-text-webpack-plugin
module.exports = {"footer-info":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlertModal-__ItemInventoryAlertModal___2skxS","body":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlertModal-__ItemInventoryAlertModal___2Q2r-","dialog":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlertModal-__ItemInventoryAlertModal___mKi9l","table":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlertModal-__ItemInventoryAlertModal___1UH8H"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemInventoryAlertModal/ItemInventoryAlertModal.css
// module id = 2426
// module chunks = 0